// Registry of the comparison pages (/compare/*), plus /faq and /about, which use
// the same template. App.js routes each one,
// prerenderedRoutes.js preloads it, scripts/prerender.mjs renders it, and
// scripts/generate-sitemap.mjs lists it in the sitemap and llms.txt. Add a page
// here and in components/SEOHead.jsx, and nowhere else.
//
// Each module exports ROUTE, UPDATED_AT, CHECKED_AT, CHECKED_LABEL, TITLE,
// SEO_TITLE, SEO_DESCRIPTION, LEDE, BODY, FAQ and SOURCES. Read the header of
// honeybook.js before writing one: the sourcing rules apply to every page.

import * as honeybook from './honeybook.js';
import * as honeybookAlternatives from './honeybookAlternatives.js';
import * as videographerCrm from './videographerCrm.js';
import * as dubsado from './dubsado.js';
import * as studioNinja from './studioNinja.js';
import * as pixieset from './pixieset.js';
import * as picTime from './picTime.js';
import * as shootproof from './shootproof.js';
import * as galleryPlatforms from './galleryPlatforms.js';
import * as vscoWorkspace from './vscoWorkspace.js';
import * as vidflow from './vidflow.js';
import * as faq from './faq.js';
import * as about from './about.js';

export const COMPARE_PAGES = [
  honeybook,
  dubsado,
  studioNinja,
  pixieset,
  picTime,
  shootproof,
  vscoWorkspace,
  vidflow,
  honeybookAlternatives,
  videographerCrm,
  galleryPlatforms,
  // Not comparisons, but the same prerendered template: the FAQ hub and About.
  faq,
  about,
];
